
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35449',
  depVersions: {
  "documents-public-ui": "static-1.35449",
  "atom": "static-1.5497",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2902",
  "client-types": "static-1.505",
  "cssUtils": "static-1.1041",
  "customer-data-filters-ui": "static-1.41223",
  "customer-data-objects": "static-1.8113",
  "customer-data-property-utils": "static-1.8465",
  "documents-lib": "static-1.35454",
  "emoji-mart": "static-3.6",
  "flux-actions": "static-1.379",
  "FormsCommonComponents": "static-1.86749",
  "FormUrlGenerator": "static-2.5133",
  "foundations-theming-specialty": "static-1.2616",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6009",
  "hs-test-utils": "static-1.8458",
  "hub-http": "static-1.6628",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12217",
  "HubStyleTokens": "static-2.11910",
  "I18n": "static-7.1693",
  "icons": "static-2.699",
  "jasmine-immutable": "static-1.3371",
  "jasmine-runner": "static-1.6869",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7570",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3306",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5799",
  "quartz": "static-1.7591",
  "react": "static-7.202",
  "react-dlb": "static-1.92",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17152",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5627",
  "react-virtualized": "static-2.111",
  "reference-resolvers": "static-1.8597",
  "reference-resolvers-lite": "static-1.8525",
  "reporting-data": "static-1.69190",
  "reporting-reports": "static-1.68866",
  "reporting-snowflake": "static-1.57806",
  "reporting-testing-lib": "static-1.11123",
  "reporting-visualizations": "static-1.61264",
  "reselect": "static-3.15",
  "sales-content-partitioning": "static-1.9378",
  "sanitize": "static-1.4892",
  "sanitize-text": "static-1.8576",
  "SharedI18nStrings": "static-1.186",
  "SharedLegalStrings": "static-1.2148",
  "signup-constants": "static-1.19845",
  "signup-ui-url-generator": "static-2.8478",
  "StyleGuideUI": "static-3.513",
  "superstore": "static-1.5178",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5165",
  "ui-addon-form-validation": "static-1.11339",
  "ui-asset-management-lib": "static-1.11521",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8856",
  "usage-tracker": "static-1.7733",
  "usage-tracker-container": "static-1.7723",
  "usage-tracker-core": "static-1.7583",
  "viral-links-lib": "static-1.7499",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10065",
  "foundations-components": "static-1.8661",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1369",
  "quartz-core": "static-1.6810",
  "quick-fetch": "static-1.4195",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "rpc-client-utils": "static-1.5089",
  "ui-addon-i18n": "static-1.11565",
  "ui-addon-upgrades": "static-9.18511",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3868",
  "quartz-webpack": "static-1.3815",
  "foundations-assets": "static-1.5305",
  "foundations-theming": "static-1.4900",
  "hub-http-janus": "static-1.898",
  "hub-http-shared-msw-handlers": "static-1.10811",
  "hubspotter-http": "static-1.4932",
  "sassPrefix": "static-1.308",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43996",
  "customer-data-filters-ui-msw-helpers": "static-1.23658",
  "customer-data-objects-ui-components": "static-1.13449",
  "customer-data-reference-ui-components": "static-1.13586",
  "customer-data-ui-utilities": "static-1.10252",
  "events-data-lib": "static-1.666",
  "framework-builder-read-service-client": "static-1.4292",
  "hs-resources": "static-1.615",
  "immer": "static-1.104",
  "inbound-db-meta-service-client": "static-1.3744",
  "inbound-db-properties-service-client": "static-1.4112",
  "multi-account-reference-resolvers": "static-1.1423",
  "onboarding-scopes": "static-1.6871",
  "onboarding-tours": "static-1.17304",
  "pulse": "static-1.1058",
  "reporting-datasets-permissions-lib": "static-1.14674",
  "segments-client-types": "static-1.11981",
  "stylex": "static-1.45",
  "trellis-assets": "static-1.2953",
  "trellis-components": "static-1.2972",
  "trellis-theming": "static-1.1402",
  "ui-addon-teams": "static-1.21968",
  "quartz-auth": "static-1.1266",
  "ui-business-units-lib": "static-1.9514",
  "usage-tracker-session-replay": "static-1.5419",
  "ai-components-ui-library": "static-1.9928",
  "ContentUtils": "static-1.69348",
  "customer-data-properties": "static-1.52887",
  "forms-ai-lib": "static-1.4903",
  "forms-utils-lib": "static-1.13253",
  "foundations-components-test-utils": "static-1.6144",
  "react-dnd-compat": "static-1.5030",
  "react-tinymce": "static-1.56175",
  "tinymce-config": "static-2.55301",
  "ui-gdpr-components": "static-1.10650",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3885",
  "HeadJS": "static-2.813",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3569",
  "msw": "static-1.39",
  "msw-config": "static-1.20",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.365",
  "ui-fonts": "static-1.1172",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4728",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1256",
  "web-vitals": "static-1.18",
  "batch-promise": "static-1.1965",
  "external-options-client-types": "static-1.4413",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1266",
  "frontend-preferences-client": "static-1.8337",
  "graphql": "static-1.92",
  "persist-promise": "static-1.4122",
  "reporting-client-types": "static-1.2784",
  "apollo-stack-hubspot": "static-3.98",
  "growth-payments-core": "static-1.26401",
  "hubspot-apollo-client": "static-1.5294",
  "foundations-components-legacy": "static-1.1686",
  "quartz-routing": "static-1.1021",
  "hs-story-utils": "static-1.9844",
  "react-flip-move": "static-1.82",
  "nested-table": "static-1.655",
  "seat-types-lib": "static-1.947",
  "timezone-utils": "static-2.5650",
  "react-create-root-preference": "static-1.90",
  "bend-plugin-foundations-components": "static-1.4930",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "tanstack-table": "static-1.65",
  "opentelemetry-fe-types": "static-1.205",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.596",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.580",
  "quartz-test": "static-1.1266",
  "quartz-tracking": "static-1.970",
  "bend-plugin-chirp-manifest": "static-1.499",
  "chirp-fetch": "static-1.2320",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6564",
  "ts-schema": "static-1.4364",
  "bender-build-tools": "static-1.3518",
  "bend-plugin-foundations-theming": "static-1.3383",
  "restore-request-side-panel-lib": "static-1.1919",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5020",
  "conditional-properties-service-client": "static-1.4086",
  "crm-pipelines-api-client-types": "static-1.4417",
  "event-emitter": "static-1.1378",
  "fdsr-migration-layer": "static-1.431",
  "multi-currency-client-types": "static-1.3981",
  "getting-started-shared-tasks": "static-1.19468",
  "growth-data-modal": "static-1.6054",
  "growth-onboarding-confetti": "static-1.3483",
  "growth-onboarding-next-action-utils": "static-1.2892",
  "navigation-components": "static-1.19063",
  "onboarding-tours-client": "static-1.5519",
  "onboarding-tours-utils": "static-1.1371",
  "ui-shepherd-react": "static-3.10694",
  "ui-shepherd-tracker": "static-1.8075",
  "ui-universal-auth": "static-1.9625",
  "user-context": "static-1.5478",
  "bend-plugin-pulse": "static-1.561",
  "fast-json-patch": "static-1.73",
  "crm-index-associations-lib": "static-1.6868",
  "stylex-utils": "static-1.161",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "hubspotter-http-shared-msw-handlers": "static-1.10809",
  "magpie-lib": "static-1.5854",
  "navigation-messaging": "static-1.8390",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23516",
  "copilot-toolkit": "static-1.12049",
  "cms-field-types": "static-1.5231",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17304",
  "calling-global-api": "static-1.66020",
  "calling-internal-common": "static-1.31741",
  "calling-lifecycle-internal": "static-1.67402",
  "calling-lifecycle-messages": "static-1.59695",
  "commerce-products-lib": "static-1.10767",
  "crm-index-visualization-core": "static-1.4681",
  "crm-links": "static-1.6723",
  "customer-data-properties-shared-msw-handlers": "static-1.10138",
  "file-manager-components": "static-1.24747",
  "formula-editor": "static-1.14936",
  "framework-data-schema-resolvers": "static-1.7312",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4494",
  "meetings-icalendar-utils-lib": "static-1.1056",
  "object-builder-ui-client": "static-1.49918",
  "pipeline-validation-client-types": "static-1.4253",
  "property-value-citations": "static-1.3501",
  "smart-data-capture-core": "static-1.359",
  "smart-property-lib": "static-1.8528",
  "tiered-pricing": "static-1.2147",
  "topics-actions-lib": "static-1.594",
  "trial-components-library": "static-1.14293",
  "ui-addon-iframeable": "static-1.9497",
  "zustand": "static-1.88",
  "final-form": "static-1.82",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.81",
  "rich-text-lib": "static-1.20473",
  "tinymce-themes": "static-1.57271",
  "data-token-picker": "static-1.17046",
  "hub-http-contrib": "static-1.3447",
  "interframe": "static-3.5160",
  "tinymce-data": "static-1.41386",
  "tinymce-plugins": "static-1.58415",
  "ui-addon-sales-email": "static-1.5622",
  "ui-addon-opt": "static-4.8800",
  "hubspot-apollo-cache": "static-1.753",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.567",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.119",
  "purchase-motions-api": "static-1.6567",
  "onboarding-data-sync-lib": "static-1.2753",
  "growth-onboarding-next-action-components": "static-1.2920",
  "user-context-client": "static-1.4928",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5314",
  "nest": "static-1.653",
  "reactive-lib": "static-1.1142",
  "simple-logging-lib": "static-1.3471",
  "unified-auth-core-lib": "static-1.1421",
  "getting-started-shared-tasks-store": "static-1.18586",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2011",
  "integrations-error-boundary-lib": "static-1.14719",
  "integrations-tracking-lib": "static-1.6031",
  "native-integrations-shared-strings": "static-1.8181",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10791",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1139",
  "calling-error-reporting": "static-1.31748",
  "shared-worker-versioning": "static-1.11460",
  "calling-usage-tracker": "static-1.6954",
  "voice-sms-access-library": "static-1.2317",
  "customer-data-tracking": "static-1.7292",
  "commerce-permissions": "static-1.1196",
  "products-iframe-lib": "static-1.8806",
  "products-ui-components-shared-msw-handlers": "static-1.11193",
  "framework-data-schema-quick-fetch": "static-1.7217",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10894",
  "sales-views-client-types": "static-1.4678",
  "location-customization-utils-lib": "static-1.10323",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4561",
  "poll-commands": "static-1.3892",
  "video-components-external": "static-1.12335",
  "video-data-lib": "static-1.35993",
  "bark-lib": "static-1.16949",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6308",
  "react-codemirror": "static-1.11059",
  "data-agent-kit": "static-1.809",
  "feedback-loader": "static-1.29980",
  "fsm": "static-1.4173",
  "policy-lib": "static-1.7226",
  "react-colorpicker": "static-2.10631",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10957",
  "embedded-academy-lib": "static-1.15849",
  "hubs-service-types": "static-1.1684",
  "nudge-client-utils": "static-1.3320",
  "salesImages": "static-1.677",
  "FileManagerLib": "static-1.40387",
  "NamespacedHubStyle": "static-2.9328",
  "FileManagerCore": "static-1.40246",
  "content-assistance-lib": "static-1.8346",
  "layout-dnd-components": "static-1.13136",
  "layout-dnd-utils": "static-1.12111",
  "ui-addon-emoji-picker": "static-1.10286",
  "ui-brand-identity-lib": "static-1.16800",
  "InboxConnectUtils": "static-4.15753",
  "meetings-connect-utils-lib": "static-1.8035",
  "breeze-engine-chat-components": "static-1.989",
  "breeze-engine-core": "static-1.1289",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "universal-page-editor-lib": "static-1.3429",
  "adobe-sign-auth-lib": "static-1.670",
  "ads-unified-auth-lib": "static-1.1774",
  "custom-vendor-connection-lib": "static-1.189",
  "google-sheets-integration-lib": "static-1.1235",
  "microsoft-drive-auth-lib": "static-1.397",
  "surveymonkey-integration-lib": "static-1.766",
  "slack-ui-library": "static-1.10816",
  "calling-orchestration-schema": "static-1.37094",
  "crm-record-cards-service-types": "static-1.3834",
  "content-media-composition-data-lib": "static-1.13486",
  "content-media-compositions": "static-2.17493",
  "media-bridge-lib": "static-1.19561",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16573",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4922",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15309",
  "nudge-custom-function-registry": "static-1.3077",
  "nudge-renderer-utils": "static-1.3396",
  "whisper-core-api": "static-1.7540",
  "audio-components": "static-1.6494",
  "FileManagerImages": "static-1.37898",
  "video-components": "static-1.14337",
  "breeze-artifacts-sdk": "static-1.685",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4936",
  "video-embed": "static-1.36827",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29511",
  "ContentData": "static-1.69423",
  "layout-data-lib": "static-1.10436",
  "academy-service-client": "static-1.4112",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4813",
  "trellis-ecosystem": "static-1.7773",
  "ui-addon-react-router-dom": "static-1.9948",
  "wootric-nps": "static-1.7266",
  "social-insights-client-types": "static-1.22840",
  "outpost": "static-1.4553",
  "growth-onboarding-feedback-components": "static-1.7002",
  "advanced-menus-core": "static-1.15734",
  "advanced-menus-lib": "static-1.12512",
  "ExportDialog": "static-6.10792",
  "ui-memberships-settings-lib": "static-1.35085",
  "marketplace-ui-apps-core": "static-1.19493",
  "marketplace-ui-common": "static-1.20961",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15733",
  "simple-menus-lib": "static-1.17250",
  "settings-ui-lib": "static-1.12949",
  "developer-experience-shared-components": "static-1.10956",
  "immutable-less": "static-1.5069",
  "marketplace-ui-client-types": "static-1.18368",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-extensibility-client-types": "static-1.4336",
  "ai-settings-ui-library": "static-1.8499",
  "nav-meta": "static-1.30700",
  "ui-product-approvals-common": "static-1.1432",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3729"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35449",
  "atom": "/atom/static-1.5497",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2902",
  "client-types": "/client-types/static-1.505",
  "cssUtils": "/cssUtils/static-1.1041",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41223",
  "customer-data-objects": "/customer-data-objects/static-1.8113",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8465",
  "documents-lib": "/documents-lib/static-1.35454",
  "emoji-mart": "/emoji-mart/static-3.6",
  "flux-actions": "/flux-actions/static-1.379",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86749",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5133",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2616",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6009",
  "hs-test-utils": "/hs-test-utils/static-1.8458",
  "hub-http": "/hub-http/static-1.6628",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12217",
  "HubStyleTokens": "/HubStyleTokens/static-2.11910",
  "I18n": "/I18n/static-7.1693",
  "icons": "/icons/static-2.699",
  "jasmine-immutable": "/jasmine-immutable/static-1.3371",
  "jasmine-runner": "/jasmine-runner/static-1.6869",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7570",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3306",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5799",
  "quartz": "/quartz/static-1.7591",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17152",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5627",
  "react-virtualized": "/react-virtualized/static-2.111",
  "reference-resolvers": "/reference-resolvers/static-1.8597",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8525",
  "reporting-data": "/reporting-data/static-1.69190",
  "reporting-reports": "/reporting-reports/static-1.68866",
  "reporting-snowflake": "/reporting-snowflake/static-1.57806",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11123",
  "reporting-visualizations": "/reporting-visualizations/static-1.61264",
  "reselect": "/reselect/static-3.15",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9378",
  "sanitize": "/sanitize/static-1.4892",
  "sanitize-text": "/sanitize-text/static-1.8576",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2148",
  "signup-constants": "/signup-constants/static-1.19845",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8478",
  "StyleGuideUI": "/StyleGuideUI/static-3.513",
  "superstore": "/superstore/static-1.5178",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5165",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11339",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11521",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8856",
  "usage-tracker": "/usage-tracker/static-1.7733",
  "usage-tracker-container": "/usage-tracker-container/static-1.7723",
  "usage-tracker-core": "/usage-tracker-core/static-1.7583",
  "viral-links-lib": "/viral-links-lib/static-1.7499",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10065",
  "foundations-components": "/foundations-components/static-1.8661",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1369",
  "quartz-core": "/quartz-core/static-1.6810",
  "quick-fetch": "/quick-fetch/static-1.4195",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.5089",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11565",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18511",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3868",
  "quartz-webpack": "/quartz-webpack/static-1.3815",
  "foundations-assets": "/foundations-assets/static-1.5305",
  "foundations-theming": "/foundations-theming/static-1.4900",
  "hub-http-janus": "/hub-http-janus/static-1.898",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10811",
  "hubspotter-http": "/hubspotter-http/static-1.4932",
  "sassPrefix": "/sassPrefix/static-1.308",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43996",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23658",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13449",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13586",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10252",
  "events-data-lib": "/events-data-lib/static-1.666",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4292",
  "hs-resources": "/hs-resources/static-1.615",
  "immer": "/immer/static-1.104",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3744",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4112",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1423",
  "onboarding-scopes": "/onboarding-scopes/static-1.6871",
  "onboarding-tours": "/onboarding-tours/static-1.17304",
  "pulse": "/pulse/static-1.1058",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14674",
  "segments-client-types": "/segments-client-types/static-1.11981",
  "stylex": "/stylex/static-1.45",
  "trellis-assets": "/trellis-assets/static-1.2953",
  "trellis-components": "/trellis-components/static-1.2972",
  "trellis-theming": "/trellis-theming/static-1.1402",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "quartz-auth": "/quartz-auth/static-1.1266",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9514",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5419",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9928",
  "ContentUtils": "/ContentUtils/static-1.69348",
  "customer-data-properties": "/customer-data-properties/static-1.52887",
  "forms-ai-lib": "/forms-ai-lib/static-1.4903",
  "forms-utils-lib": "/forms-utils-lib/static-1.13253",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6144",
  "react-dnd-compat": "/react-dnd-compat/static-1.5030",
  "react-tinymce": "/react-tinymce/static-1.56175",
  "tinymce-config": "/tinymce-config/static-2.55301",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10650",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3885",
  "HeadJS": "/HeadJS/static-2.813",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3569",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.20",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.365",
  "ui-fonts": "/ui-fonts/static-1.1172",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4728",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1256",
  "web-vitals": "/web-vitals/static-1.18",
  "batch-promise": "/batch-promise/static-1.1965",
  "external-options-client-types": "/external-options-client-types/static-1.4413",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1266",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8337",
  "graphql": "/graphql/static-1.92",
  "persist-promise": "/persist-promise/static-1.4122",
  "reporting-client-types": "/reporting-client-types/static-1.2784",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "growth-payments-core": "/growth-payments-core/static-1.26401",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5294",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1686",
  "quartz-routing": "/quartz-routing/static-1.1021",
  "hs-story-utils": "/hs-story-utils/static-1.9844",
  "react-flip-move": "/react-flip-move/static-1.82",
  "nested-table": "/nested-table/static-1.655",
  "seat-types-lib": "/seat-types-lib/static-1.947",
  "timezone-utils": "/timezone-utils/static-2.5650",
  "react-create-root-preference": "/react-create-root-preference/static-1.90",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4930",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "tanstack-table": "/tanstack-table/static-1.65",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.205",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.596",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.580",
  "quartz-test": "/quartz-test/static-1.1266",
  "quartz-tracking": "/quartz-tracking/static-1.970",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.499",
  "chirp-fetch": "/chirp-fetch/static-1.2320",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6564",
  "ts-schema": "/ts-schema/static-1.4364",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3383",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1919",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5020",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4086",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4417",
  "event-emitter": "/event-emitter/static-1.1378",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.431",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3981",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19468",
  "growth-data-modal": "/growth-data-modal/static-1.6054",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3483",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2892",
  "navigation-components": "/navigation-components/static-1.19063",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5519",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1371",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10694",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8075",
  "ui-universal-auth": "/ui-universal-auth/static-1.9625",
  "user-context": "/user-context/static-1.5478",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.561",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6868",
  "stylex-utils": "/stylex-utils/static-1.161",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10809",
  "magpie-lib": "/magpie-lib/static-1.5854",
  "navigation-messaging": "/navigation-messaging/static-1.8390",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23516",
  "copilot-toolkit": "/copilot-toolkit/static-1.12049",
  "cms-field-types": "/cms-field-types/static-1.5231",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17304",
  "calling-global-api": "/calling-global-api/static-1.66020",
  "calling-internal-common": "/calling-internal-common/static-1.31741",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67402",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59695",
  "commerce-products-lib": "/commerce-products-lib/static-1.10767",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4681",
  "crm-links": "/crm-links/static-1.6723",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10138",
  "file-manager-components": "/file-manager-components/static-1.24747",
  "formula-editor": "/formula-editor/static-1.14936",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7312",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4494",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1056",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49918",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4253",
  "property-value-citations": "/property-value-citations/static-1.3501",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.359",
  "smart-property-lib": "/smart-property-lib/static-1.8528",
  "tiered-pricing": "/tiered-pricing/static-1.2147",
  "topics-actions-lib": "/topics-actions-lib/static-1.594",
  "trial-components-library": "/trial-components-library/static-1.14293",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9497",
  "zustand": "/zustand/static-1.88",
  "final-form": "/final-form/static-1.82",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "rich-text-lib": "/rich-text-lib/static-1.20473",
  "tinymce-themes": "/tinymce-themes/static-1.57271",
  "data-token-picker": "/data-token-picker/static-1.17046",
  "hub-http-contrib": "/hub-http-contrib/static-1.3447",
  "interframe": "/interframe/static-3.5160",
  "tinymce-data": "/tinymce-data/static-1.41386",
  "tinymce-plugins": "/tinymce-plugins/static-1.58415",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5622",
  "ui-addon-opt": "/ui-addon-opt/static-4.8800",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.753",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.567",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.119",
  "purchase-motions-api": "/purchase-motions-api/static-1.6567",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2753",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2920",
  "user-context-client": "/user-context-client/static-1.4928",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5314",
  "nest": "/nest/static-1.653",
  "reactive-lib": "/reactive-lib/static-1.1142",
  "simple-logging-lib": "/simple-logging-lib/static-1.3471",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1421",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18586",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2011",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14719",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6031",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8181",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10791",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1139",
  "calling-error-reporting": "/calling-error-reporting/static-1.31748",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11460",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6954",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2317",
  "customer-data-tracking": "/customer-data-tracking/static-1.7292",
  "commerce-permissions": "/commerce-permissions/static-1.1196",
  "products-iframe-lib": "/products-iframe-lib/static-1.8806",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11193",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7217",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10894",
  "sales-views-client-types": "/sales-views-client-types/static-1.4678",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10323",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4561",
  "poll-commands": "/poll-commands/static-1.3892",
  "video-components-external": "/video-components-external/static-1.12335",
  "video-data-lib": "/video-data-lib/static-1.35993",
  "bark-lib": "/bark-lib/static-1.16949",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6308",
  "react-codemirror": "/react-codemirror/static-1.11059",
  "data-agent-kit": "/data-agent-kit/static-1.809",
  "feedback-loader": "/feedback-loader/static-1.29980",
  "fsm": "/fsm/static-1.4173",
  "policy-lib": "/policy-lib/static-1.7226",
  "react-colorpicker": "/react-colorpicker/static-2.10631",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10957",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15849",
  "hubs-service-types": "/hubs-service-types/static-1.1684",
  "nudge-client-utils": "/nudge-client-utils/static-1.3320",
  "salesImages": "/salesImages/static-1.677",
  "FileManagerLib": "/FileManagerLib/static-1.40387",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9328",
  "FileManagerCore": "/FileManagerCore/static-1.40246",
  "content-assistance-lib": "/content-assistance-lib/static-1.8346",
  "layout-dnd-components": "/layout-dnd-components/static-1.13136",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12111",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10286",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16800",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15753",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8035",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.989",
  "breeze-engine-core": "/breeze-engine-core/static-1.1289",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3429",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.670",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1774",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.189",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1235",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.397",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.766",
  "slack-ui-library": "/slack-ui-library/static-1.10816",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37094",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13486",
  "content-media-compositions": "/content-media-compositions/static-2.17493",
  "media-bridge-lib": "/media-bridge-lib/static-1.19561",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16573",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4922",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15309",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3077",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3396",
  "whisper-core-api": "/whisper-core-api/static-1.7540",
  "audio-components": "/audio-components/static-1.6494",
  "FileManagerImages": "/FileManagerImages/static-1.37898",
  "video-components": "/video-components/static-1.14337",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.685",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4936",
  "video-embed": "/video-embed/static-1.36827",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29511",
  "ContentData": "/ContentData/static-1.69423",
  "layout-data-lib": "/layout-data-lib/static-1.10436",
  "academy-service-client": "/academy-service-client/static-1.4112",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4813",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7773",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9948",
  "wootric-nps": "/wootric-nps/static-1.7266",
  "social-insights-client-types": "/social-insights-client-types/static-1.22840",
  "outpost": "/outpost/static-1.4553",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7002",
  "advanced-menus-core": "/advanced-menus-core/static-1.15734",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "ExportDialog": "/ExportDialog/static-6.10792",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35085",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19493",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20961",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15733",
  "simple-menus-lib": "/simple-menus-lib/static-1.17250",
  "settings-ui-lib": "/settings-ui-lib/static-1.12949",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10956",
  "immutable-less": "/immutable-less/static-1.5069",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18368",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4336",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8499",
  "nav-meta": "/nav-meta/static-1.30700",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1432",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3729"
}
};
